import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  activeView: "Welcome",
  previousView: "",
  modalState: {
    state: null as string & null,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: {} as any,
  },
  snackBarMessage: {
    message: "" as string,
    closeText: "" as string,
  },
  quickTileChange: {
    label: "" as string,
    tileType: "" as string,
    tileKey: "" as string,
    placeholder: "" as string,
  },
};

const viewSlice = createSlice({
  name: "view",
  initialState,
  reducers: {
    setActiveView: (state, action) => {
      state.activeView = action.payload;
    },
    setModalState: (state, action) => {
      state.modalState = action.payload;
    },
    setSnackBarMessage: (state, action) => {
      state.snackBarMessage = action.payload;
    },
    removeSnackBarMessage: (state) => {
      state.snackBarMessage = {
        message: "",
        closeText: "",
      };
    },
    setQuickTileChange: (state, action) => {
      state.quickTileChange = action.payload;
    },
    setPreviousView: (state, action) => {
      state.previousView = action.payload;
    },
  },
});

export const {
  setActiveView,
  setModalState,
  setSnackBarMessage,
  removeSnackBarMessage,
  setQuickTileChange,
  setPreviousView,
} = viewSlice.actions;
export default viewSlice.reducer;
